import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { Navigation, Autoplay } from "swiper";

// Desktop Images
import Banner1 from "../../assets/img/home2/Banner1.jpg";
import Banner5 from "../../assets/img/home2/UltraLiteBanner.jpg";
import Banner2 from "../../assets/img/home2/Banner2.jpg";
import Banner3 from "../../assets/img/home2/BannerCorn.jpg";
import Banner4 from "../../assets/img/home2/Banner4.jpg";

// Mobile Images
import MobileBanner1 from "../../assets/img/home2/MobileBanner1.jpg";
import MobileBanner2 from "../../assets/img/home2/MobileBanner2.jpg";
import MobileBanner3 from "../../assets/img/home2/MobileBannerCorn.jpg";
import MobileBanner4 from "../../assets/img/home2/MobileBanner4.jpg";
import MobileBanner5 from "../../assets/img/home2/MobileBanner5.jpg";
import { Link } from "react-router-dom";

const HeroTwo = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const desktopImages = [Banner5,Banner1, Banner2, Banner3, Banner4];
  const mobileImages = [MobileBanner5,MobileBanner1, MobileBanner2, MobileBanner3, MobileBanner4];
  

  return (
    <section className="hero-wrapper hero-2">
      <Swiper
        navigation={true}
        modules={[Navigation, Autoplay]}
        loop
        autoplay={{ delay: 5000, disableOnInteraction: true }}
      >
        {(isMobile ? mobileImages : desktopImages).map((banner, index) => (
          <SwiperSlide key={index} className="hero-slider-2">
            <div className="single-slide">
              <img src={banner} alt={`Slide ${index + 1}`} className="slide-image" loading="lazy"  style={isMobile ? { height: "100vh" } : {}}/>
              {/* <div className="row">
                  <div className="col-md-6">
                      <img src={banner} alt={`Slide ${index + 1}`} className="slide-image" loading="lazy"  style={isMobile ? { height: "100vh" } : {}}/>
                  </div>
                  <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-center" style={{backgroundColor:'lightyellow'}}>
                    <h2>Hello, this is product</h2>
                    <p>kjhrgf eltgjrher tkryr ytrklyjuiry rlyrji</p>

                    <div>
                      <button className="btn btn-outline-success me-2">Contact</button>
                      <button className="btn btn-outline-primary">Visit</button>
                    </div>
                  </div>
              </div> */}
              {/* <Link className="theme-btn mt-35" style={{
                position: "absolute",
                left:"10%",
                top: "70%",
              }}>Gold Coin Where Housing</Link> */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Styles for Responsiveness */}
      <style jsx>{`
        .single-slide {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .slide-image {
          width: 100%;
          height: auto;
          object-fit: cover;
        }

        @media (max-width: 1024px) {
          .single-slide {
            height: 60vh;
          }
        }

        @media (max-width: 768px) {
          .single-slide {
            height: 100vh;
          }
        }
      `}</style>
    </section>
  );
};

export default HeroTwo;
